import { GCUserProperty } from '@apply/api/src/api/ApplyApi';

export const addressBuilder = (property: GCUserProperty): string => {
    if (!property.street1 && !property.street2) {
        return 'Unable to Determine Street Address';
    }
    const streetPart = property.street2 ? `${property.street1} ${property.street2}` : property.street1;
    const cityStateZip = `${property.city} ${property.state}, ${property.zipCode}`;
    return `${streetPart}, ${cityStateZip}`.trim();
};
